import React from 'react';
import PropTypes from 'prop-types';

import CustomTableV2 from '@ey/canvascoreservices/CustomTableV2';
import Accordion from '../Accordion';

const CustomTable = ({...rest}) => <CustomTableV2 {...rest} Accordion={Accordion} />;

CustomTable.propTypes = {};

export default CustomTable;
